<template>
    <div class="col-md-4 mt-4">
        <div class="card card-blog">
            <div class="card-img">
            <a :href="`/externalBlog/${blogPost.id}`">
                <img v-if="blogPost.tipoatracao == 2" :src="`images/blog/posts/${blogPost.atracao}`" alt="" class="img-fluid">
                <div class="embed-responsive embed-responsive-16by9" v-if="blogPost.tipoatracao == 1">
                    <iframe class="embed-responsive-item" :src="`https://www.youtube.com/embed/${blogPost.atracao}`" frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope" allowfullscreen></iframe>
                </div>
            </a>
            </div>
            <div class="card-body">
            <div class="card-category-box">
                <div class="card-category ml-1" v-for="categoria in blogPost.categorias" v-bind:key="categoria.id">
                <h6 class="category"><i class="fas fa-tag"></i> {{ categoria.name }}</h6>
                </div>
            </div>
            <h3 class="card-title"><a :href="`/externalBlog/${blogPost.id}`">{{ blogPost.titulo }}</a></h3>
            <p class="card-description">
                {{ blogPost.subtitulo }}
            </p>
            </div>
            <div class="card-footer">
            <div class="post-author">
                <a href="#">
                <img :src="`images/profiles/${blogPost.autorPhoto}`" alt="" class="avatar rounded-circle">
                <span class="author">{{ blogPost.autor }}</span>
                </a>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            blogPost: {
                required: true
            }
        }
    }
</script>